<script>
import { mapActions, mapState } from 'vuex'

import ButtonExtender from './button-extender.vue'
import ButtonTerminator from './button-terminator.vue'
import ReservationClock from './reservation-clock.vue'

export default {
  props: ['extensions_enabled'],

  components: {
    ButtonExtender,
    ButtonTerminator,
    ReservationClock,
  },

  computed: {
    ...mapState({
      content_module: state => {
        let transaction = state.reservation.reservation_transactions.find(
          t => t.id === state.reservation.current.id
        )
        return state.content.content_modules.find(
          p => p.id === transaction.relationships.content_module.data.id
        )
      },
      current: state => state.reservation.current,
      infrastructure_pod: state => {
        let transaction = state.reservation.reservation_transactions.find(
          t => t.id === state.reservation.current.id
        )
        return state.infrastructure.infrastructure_pods.find(
          p => p.id === transaction.relationships.infrastructure_pod.data.id
        )
      },
      reservation_transaction: state =>
        state.reservation.reservation_transactions.find(
          t => t.id === state.reservation.current.id
        ),
      topology_blueprint: state => {
        let transaction = state.reservation.reservation_transactions.find(
          t => t.id === state.reservation.current.id
        )
        return state.topology.topology_blueprints.find(
          p => p.id === transaction.relationships.topology_blueprint.data.id
        )
      }
    }),

    isActiveStatus: function () {
      return this.reservation_transaction &&
        // Reserved/provisioned status
        this.infrastructure_pod.attributes.pod_status > 2
    },

    isCourse: function () {
      return this.reservation_transaction &&
        this.reservation_transaction.attributes.content_module_id != 0
    },

    isTopology: function () {
      return this.reservation_transaction &&
        this.reservation_transaction.attributes.content_module_id == 0
    },

    isVisible: function () {
      return this.current.id != 0
    },

    isExpiring: function () {
      return this.current.is_expiring &&
        this.extensions_enabled
    }
  }
}
</script>

<template>
  <div class="-mx-4">
    <div class="z-30 bg-white rounded-b-3xl shadow-lg px-12 py-4" v-if="isVisible" transition="expand-vertical">
      <div class="flex flex-col lg:flex-row space-x-4 space-y-4 lg:space-y-0">
        <div class="flex-1">
          <div class="flex flex-row items-center space-x-6">
            <div class="">
              <div class="flex flex-row items-center space-x-2" :class="{ 'text-green-600' : isActiveStatus, 'text-riverbed-yellow' : !isActiveStatus }" >
                <div class="rounded-full h-3 w-3 circle" :class="{ 'bg-green-500' : isActiveStatus, 'bg-riverbed-yellow' : !isActiveStatus }" ></div>
                <div>{{ isActiveStatus ? 'Active' : 'Provisioning' }}</div>
              </div>
            </div>
            <div class="">
              <div class="text-sm">{{ reservation_transaction.attributes.transaction_type }}</div>
              <div class="font-bold" v-if="isTopology">
                {{ topology_blueprint.id }} &ndash;
                {{ topology_blueprint.attributes.blueprint_name }}
              </div>
              <div class="font-bold" v-if="isCourse">
                HOL{{ content_module.attributes.module_alias }} &ndash;
                {{ content_module.attributes.module_name }}
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col sm:flex-row items-center justify-center sm:items-start lg:justify-start sm:space-x-4 space-y-6 sm:space-y-0">
          <div>
            <reservation-clock></reservation-clock>
          </div>
          <div class="flex flex-row space-x-2">
            <a class="rounded-full relative inline-flex items-center mx-auto group px-4 py-2 text-center text-base font-bold uppercase whitespace-nowrap overflow-hidden border-2 border-riverbed-fuchsia text-riverbed-fuchsia bg-white hover:text-white hover:no-underline hover:bg-riverbed-fuchsia active:bg-riverbed-fuchsia active:text-white active:no-underline focus:bg-riverbed-fuchsia focus:text-white focus:no-underline ease-in-out duration-300 shadow md:after:absolute md:after:origin-center md:after:h-80 md:after:top-0 md:after:bottom-0 md:after:left-0 md:after:right-0 md:after:bg-riverbed-fuchsia md:after:opacity-0 md:after:scale-x-0 md:after:ease-in-out md:after:duration-300 md:hover:after:opacity-100 md:hover:after:scale-x-110 md:hover:after:rotate-12 md:hover:after:-translate-y-1/2" href="/connect">
              <span class="relative z-10">Connect</span>
            </a>
            <button-extender v-if="isExpiring"></button-extender>
            <button-terminator></button-terminator>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
